/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchCompanyRequest
 */
export interface SearchCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchCompanyRequest
     */
    query: string;
}

/**
 * Check if a given object implements the SearchCompanyRequest interface.
 */
export function instanceOfSearchCompanyRequest(value: object): value is SearchCompanyRequest {
    if (!('query' in value) || value['query'] === undefined) return false;
    return true;
}

export function SearchCompanyRequestFromJSON(json: any): SearchCompanyRequest {
    return SearchCompanyRequestFromJSONTyped(json, false);
}

export function SearchCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCompanyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'],
    };
}

export function SearchCompanyRequestToJSON(value?: SearchCompanyRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'query': value['query'],
    };
}

